export default __webpack_public_path__ + "static/media/kanban-card-plus.cbcc1817.svg";